import React, {Component} from 'react';
import {connect} from 'react-redux';
import RuleItems from './components/organisms/rule-items';
import {Factory as SettingsFactory} from './components/organisms/settings/factory';

class ProjectionBoostRule extends Component {
    render() {
        const {projectionBoostRule, sportConfig} = this.props;

        if (!sportConfig.isReady()) {
            return null;
        }

        const Settings = SettingsFactory.getDesktopComponent(sportConfig);

        return (
            <div className={'advanced-filter advanced-open'}>
                <Settings key={projectionBoostRule.getSignature()} />
                <RuleItems />
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {projectionBoostRule, sportConfig} = state;

    return {
        projectionBoostRule,
        sportConfig,
    };
}

export default connect(mapStatesToProps)(ProjectionBoostRule);
